// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/icon/icon.scss
// module id = 521
// module chunks = 0